export const formatDay = (type) => {
  const obj = {
    '1': '上午',
    '2': '下午'
  }
  return obj[type]
}

export const formatCensorState = (type) => {
  const obj = {
    '-1': '未审核',
    '0': '不通过',
    '1': '通过'
  }
  return obj[type]
}